import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((_nuxtApp) => {
});
